import { render, staticRenderFns } from "./recommendSetting.vue?vue&type=template&id=2f0b6fba&scoped=true&"
import script from "./recommendSetting.vue?vue&type=script&lang=js&"
export * from "./recommendSetting.vue?vue&type=script&lang=js&"
import style0 from "./recommendSetting.vue?vue&type=style&index=0&id=2f0b6fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b6fba",
  null
  
)

export default component.exports